import RemovePartnerRewardsModal from './RemovePartnerRewardsModal';

export default RemovePartnerRewardsModal;
